import React, { useState } from 'react';
import api from '~/services/api';
import { Label, Input, Select } from '~/componentes/CustomForm';

import { Container } from './styles';
// import CustomScrollBar from '~/componentes/CustomScrollBar';
import { Materialize } from '~/styles/materializeGrid';
// import { SLModalFooter } from '~/pages/Sistema/componentes/SistemaList';
import ShowConfirmacao from '~/utils/ShowConfirmacao';
import ResponsaveisList from '../ResponsaveisList';

function CreateEditContent({ mountedData }) {
  const [responsaveis, setResponsaveis] = useState([]);
  const [ativo, setAtivo] = useState(!mountedData ? 'true' : mountedData?.ativo ? 'true' : 'false');
  const [permiteOS, setPermiteOS] = useState(
    !mountedData ? 'false' : mountedData?.permiteOS ? 'true' : 'false',
  );

  async function handleSubmit(data, options) {
    const { closeReload } = options || {};

    return ShowConfirmacao(
      async () => {
        let thisData = {
          ...data,
          ...(mountedData?.id ? { id: mountedData?.id } : {}),
          ativo: ativo === 'true' ? true : false,
          responsaveis,
          tipo: 'FPJ',
          permiteOS: permiteOS === 'true' ? true : false,
        };
        let response;
        if (mountedData?.id)
          response = await api.put('/signed/empresa/gestorprojeto/etapa/etapa', thisData);
        else response = await api.post('/signed/empresa/gestorprojeto/etapa/etapa', thisData);

        if (response?.status === 200) {
          closeReload && closeReload();
        }
        return response;
      },
      {
        errorModal: {
          defaultMessage: `Ocorreu um erro ao ${
            mountedData?.id ? 'atualizar' : 'cadastrar'
          } essa Etapa, por favor, tente novamente mais tarde.`,
        },
        message: `Tem certeza que deseja ${
          mountedData?.id ? 'atualizar' : 'cadastrar'
        } essa Etapa?`,
        successModal: `Etapa ${mountedData?.id ? 'atualizada' : 'cadastrada'} com sucesso!`,
      },
    );
  }

  return (
    <Container onSubmit={handleSubmit} defaultScroll={true}>
      <Materialize className="materialize">
        <div className="row header">
          <p className="h-descricao">
            Preencha as informações corretamente, e se atente ao (*) pois são campos obrigatórios
          </p>
        </div>
        <div className="row">
          <Label title="Título *" className="col s6 m6 l6">
            <Input name="titulo" defaultValue={mountedData?.titulo} />
          </Label>
          <Label title="Posição *" className="col s2 m2 l2">
            <Input type="number" name="posicao" defaultValue={mountedData?.posicao} />
          </Label>
          <Label title="Etapa Final *" className="col s2 m2 l2">
            <Select
              isString
              list={{
                list: [
                  { id: 'S', titulo: 'Sim' },
                  { id: 'N', titulo: 'Não' },
                ],
                value: 'id',
                label: 'titulo',
              }}
              name="final"
              defaultValue={mountedData?.final}
            />
          </Label>
          <Label title="Ativo *" className="col s2 m2 l2">
            <Select
              isString
              list={{
                list: [
                  { id: 'true', titulo: 'Sim' },
                  { id: 'false', titulo: 'Não' },
                ],
                value: 'id',
                label: 'titulo',
              }}
              name="ativo"
              defaultValue={mountedData?.ativo?.toString()}
              onChange={e => {
                const v = e.currentTarget.value || 'true';
                setAtivo(v);
              }}
            />
          </Label>

          <Label title="Permitir Lançar OS" className="col s2 m2 l2">
            <Select
              isString
              list={{
                list: [
                  { id: 'true', titulo: 'Sim' },
                  { id: 'false', titulo: 'Não' },
                ],
                value: 'id',
                label: 'titulo',
              }}
              name="permiteOS"
              defaultValue={mountedData ? mountedData?.permiteOS?.toString() : 'false'}
              onChange={e => {
                const v = e.currentTarget.value || 'true';
                setPermiteOS(v);
              }}
            />
          </Label>
        </div>
        <div className="row">
          <div className="col s12 m12 l12">
            <ResponsaveisList
              setter={setResponsaveis}
              defaultData={mountedData?.responsaveis || []}
            />
          </div>
        </div>
      </Materialize>
    </Container>
  );
}

export default CreateEditContent;
